<template>
  <app-stepper-section :label="$t('message.admGenerics.message.address')">

    <v-text-field :label="$t('message.admGenerics.message.zipCode')"
                  v-model="zipCode"
                  v-validate="'required'"
                  mask="#####-###"
                  name="Cep"
                  :error-messages="errors.collect($t('message.admGenerics.message.zipCode'))"
                  @blur="findAddress()"></v-text-field>

    <v-text-field :label="$t('message.admGenerics.message.street')"
                  v-validate="'required'"
                  v-model="streetName"
                  name="Rua"
                  :error-messages="errors.collect($t('message.admGenerics.message.street'))"></v-text-field>

    <v-text-field :label="$t('message.admGenerics.message.streetNumber')"
                  v-validate="'required'"
                  v-model="streetNumber"
                  name="Número"
                  :error-messages="errors.collect($t('message.admGenerics.message.streetNumber'))"></v-text-field>

    <v-text-field :label="$t('message.admGenerics.message.neighborhood')"
                  v-validate="'required'"
                  v-model="neighborhood"
                  name="Bairro"
                  :error-messages="errors.collect($t('message.admGenerics.message.neighborhood'))"></v-text-field>

    <v-text-field :label="$t('message.admGenerics.message.city')"
                  v-validate="'required'"
                  v-model="city"
                  name="Cidade"
                  :error-messages="errors.collect($t('message.admGenerics.message.city'))"></v-text-field>

    <v-text-field :label="$t('message.admGenerics.message.state')"
                  v-validate="'required'"
                  v-model="state"
                  name="UF"
                  :error-messages="errors.collect($t('message.admGenerics.message.state'))"></v-text-field>

    <v-text-field :label="$t('message.admGenerics.message.streetExtra')"
                  v-model="extra"
                  name="Complemento"
                  :error-messages="errors.collect($t('message.admGenerics.message.streetExtra'))"></v-text-field>

  </app-stepper-section>
</template>

<script>
    import EventBus from "@packages/event-bus";
    import AppStepperSection from '../../../StepperSection'
    import userModalSection from '../mixins/user-modal-section'

    export default {
        components: {
            AppStepperSection,
        },

        data() {
            return {
                isSearching: false
            }
        },

        props: {
            value: {
                type: Object
            }
        },

        mixins: [userModalSection],

        computed: {
            zipCode: {
                get() {
                    return this.value.zipCode
                },
                set(zipCode) {
                    this.$emit('input', {...this.value, zipCode})
                },
            },
            streetName: {
                get() {
                    return this.value.streetName
                },
                set(streetName) {
                    this.$emit('input', {...this.value, streetName})
                },
            },
            streetNumber: {
                get() {
                    return this.value.streetNumber
                },
                set(streetNumber) {
                    this.$emit('input', {...this.value, streetNumber})
                },
            },
            extra: {
                get() {
                    return this.value.extra
                },
                set(extra) {
                    this.$emit('input', {...this.value, extra})
                },
            },
            neighborhood: {
                get() {
                    return this.value.neighborhood
                },
                set(neighborhood) {
                    this.$emit('input', {...this.value, neighborhood})
                },
            },
            city: {
                get() {
                    return this.value.city
                },
                set(city) {
                    this.$emit('input', {...this.value, city})
                },
            },
            state: {
                get() {
                    return this.value.state
                },
                set(state) {
                    this.$emit('input', {...this.value, state})
                },
            },
        },

        methods: {
            async findAddress(){
                if(!this.isSearching) {
                    this.isSearching = true;

                    try {
                        if (!this.zipCode || this.zipCode.replace('-', '').length < 8) {
                            EventBus.$emit("CANCEL_SPINNER");
                            return
                        }

                        EventBus.$emit("SHOW_SPINNER");

                        const address = await this.$api.address.search(this.zipCode.replace('-', ''))

                        this.value.streetName = address.streetName
                        this.value.neighborhood = address.neighborhood
                        this.value.city = address.city
                        this.value.state = address.state
                    } catch (error) {
                        console.log(error)
                    } finally {
                        EventBus.$emit("CANCEL_SPINNER");
                    }
                }
            }
        }
    }
</script>

<style scoped>
</style>
